import each from 'lodash/each'
import keys from 'lodash/keys'
import intersection from 'lodash/intersection'
import extend from 'lodash/extend'

import * as date from './date'
import * as home from './home'
import * as keyCodes from './keyCodes'
import * as upload from './upload'
import * as uploadlogs from './uploadlogs'
import * as error from './error'
import * as sort from './sort'
import * as filters from './filters'
import * as ui from './ui'
import * as accountsandloans from './accountsandloans'
import * as admincentre from './admincentre'
import * as beneficiary from './beneficiary'
import * as hierarchy from './hierarchy'
import * as partnerplan from './partnerplan'
import * as paging from './paging'
import * as templateupload from './templateupload'
import * as reports from './reports'

const files = {
  date,
  home,
  keyCodes,
  upload,
  uploadlogs,
  error,
  sort,
  filters,
  ui,
  accountsandloans,
  admincentre,
  partnerplan,
  paging,
  templateupload,
  beneficiary,
  hierarchy,
  reports,
}

// Loop through the imported constant files and check for duplicates
let constantsMutable = {}
each(keys(files), (filename) => {
  const file = files[filename]
  const duplicates = intersection(keys(constantsMutable), keys(file))
  each(duplicates, (duplicate) => {
    console.warn('Duplicate constant key found. Please fix this immediately.', { filename, duplicate }) // eslint-disable-line no-console
  })
  constantsMutable = extend(constantsMutable, file)
})

const constants = constantsMutable

export default constants



// WEBPACK FOOTER //
// ./src/constants/index.js